import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Optional,
  Output,
  Self
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { RequiredHandler } from '@financial/common-utils';
import { InputNumberConfig } from '@financial/common-components';

@Component({
  selector: 'app-percent-input',
  templateUrl: './percent-input.component.html',
  styleUrls: ['./percent-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PercentInputComponent extends RequiredHandler implements ControlValueAccessor {

  onChange: (value: any) => void = () => {};
  onTouch: (value: any) => void = () => {};

  @Output() valueChange = new EventEmitter<number>();

  @Input() readonly = false;
  @Input() disabled = false;

  private readonly defaultOptions: Partial<InputNumberConfig> = {
    maxValue: 100,
    minValue: 0,
    precision: 2,
    allowNegative: false,
    nullable: true
  };

  private _options: Partial<InputNumberConfig> = this.defaultOptions;
  public _value: number = null;

  constructor(private changeDetector: ChangeDetectorRef, @Optional() @Self() ngControl: NgControl) {
    super(ngControl);
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  get value(): number {
    return this._value;
  }

  @Input()
  set options(options: Partial<InputNumberConfig>) {
    this._options = { ...this.defaultOptions, ...options };
    this.changeDetector.markForCheck();
  }

  get options(): Partial<InputNumberConfig> {
    return this._options;
  }

  writeValue(value: any): void {
    this._value = value;
    this.changeDetector.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.changeDetector.markForCheck();
  }

  onInputChange(newValue: any) {
    let finalValue = newValue;

    if (finalValue === null || finalValue === undefined || finalValue === '') {
      finalValue = null;
    } else {
      if (this.options.maxValue !== undefined && finalValue > this.options.maxValue) {
        finalValue = this.options.maxValue;
      }

      if (this.options.minValue !== undefined && finalValue < this.options.minValue) {
        finalValue = this.options.minValue;
      }
    }

    this._value = finalValue;

    this.onChange(finalValue);

    this.onTouch(finalValue);

    this.valueChange.emit(finalValue);
  }
}
